import React from 'react';
import Button from '../../common/Button';
import AnimatedBackground from './AnimatedBackground';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <AnimatedBackground />
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">
            Transform Possibilities into Reality
          </h1>
          <p className="hero-subtitle">
            Cut through the noise and zero in on what truly counts—delivering real, measurable results with innovative solutions. You're not just adapting to change; you're driving it.
          </p>
          <div className="hero-buttons">
            <Button variant="primary" size="large">
              Talk to an Expert
            </Button>
            <Button variant="secondary" size="large">
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 